<div class="ovelray">
    <div class="text-center">
        ეს ფუნქცია რომ გამოიყენიოთ უნდა გქონდეს pro პაკეტი
    </div>
</div>
